<mat-dialog-content>
    <!-- Backdrop clicks and ESC are disabled application-wide, so this button and the one in
         the footer are the only ways out of the dialog. -->
    <button type="button" class="close" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>

    <h4 mat-dialog-title>
        <span translate>fiscalReceipts.receiptNumber</span> {{receiptNumber}}
    </h4>

    <div class="table-responsive">
        <table class="table table-sm table-bordered table-striped w-100" [hidden]="!dataLoaded">
            <thead>
                <tr>
                    <th style="width: 5%;" scope="col">&#8470;</th>
                    <th style="width: 40%;" scope="col" translate>fiscalReceipts.article</th>
                    <th style="width: 9%;" scope="col" translate>fiscalReceipts.quantity</th>
                    <th style="width: 10%;" scope="col" translate>fiscalReceipts.measureUnit</th>
                    <th style="width: 14%;" scope="col" translate>fiscalReceipts.unitPriceWithVat</th>
                    <th style="width: 10%;" scope="col" translate>fiscalReceipts.discount</th>
                    <th style="width: 12%;" scope="col" translate>fiscalReceipts.lineTotal</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items; let i = index">
                    <td>{{i + 1}}</td>
                    <td>{{item.name}}</td>
                    <td class="text-right text-nowrap">{{item.quantity | number: '1.0-2'}}</td>
                    <td>{{item.measureUnitName}}</td>
                    <td class="text-right text-nowrap">{{item.unitPrice | number: '1.2-2'}}</td>
                    <td class="text-right text-nowrap">{{item.discountPercent | number: '1.2-2'}}%</td>
                    <td class="text-right text-nowrap">{{item.total | number: '1.2-2'}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <!-- The receipt's own total, not the sum of the lines above: a discounted
                         receipt does not add up to what was charged. -->
                    <td colspan="7" class="text-right font-weight-bold">
                        <span translate>fiscalReceipts.total</span>:
                        {{receipt?.header?.total | number: '1.2-2'}} {{receipt?.header?.currencyCode}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div *ngIf="dataLoaded && items.length === 0" class="text-muted" translate>fiscalReceipts.noItems</div>

    <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>
</mat-dialog-content>

<!-- <mat-dialog-actions align="end">
    <button class="btn btn-outline-secondary" type="button" (click)="close()" translate>button.close</button>
</mat-dialog-actions> -->

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>
